import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { FailedInvites, User } from './user.model';
import { QueryParams, QueryResult } from '../../../core/store/models/query.model';

//
// User Page actions
//
export const setSelectedUserUId = createAction('[User/Page] Set Selected User UId', props<{ uId: string }>());
export const setSelectedUIds = createAction('[User/Page] Set Selected UIds', props<{ selectedUIds: Set<string> }>());
export const clearSelectedUIds = createAction('[User/Page] Clear Selected UIds');
export const showInviteForm = createAction('[User/Page] Show User Invite Form', props<{ showInviteForm: boolean }>());
export const showEditForm = createAction('[User/Page] Show User Edit', props<{ showEditForm: boolean }>());
export const setIsInviting = createAction('[User/Page] Set isInviting state', props<{ isInviting: boolean }>());
export const setIsSubmitting = createAction('[User/Page] Set isSubmitting state', props<{ isSubmitting: boolean }>());
export const saveUser = createAction('[User/Page] Save User', props<{ user: User }>());
export const updateUser = createAction('[User/Page] Update User', props<{ user: User }>());
export const setSearchTerm = createAction('[User/Page] Set Search Term', props<{ searchTerm: string }>());

//
// User API actions
//
export const getUsers = createAction('[User/API] Get Users', props<{ params: Partial<QueryParams> }>());
export const loadUsers = createAction('[User/API] Load Users', props<{ results: QueryResult<User> }>());
export const updateTotalUserCount = createAction('[User/API] Update Total User Count');
export const setTotalUserCount = createAction('[User/API] Set Total User Count', props<{ totalUserCount: number }>());
export const inviteUsers = createAction('[User/API] Invite Users', props<{ users: Array<Partial<User>> }>());
export const invitesSent = createAction('[User/API] Invites Sent');
export const setError = createAction('[User/API] Set Error', props<{ err: any }>());
export const deleteUser = createAction('[User/API] Delete User', props<{ userUId: string }>());
export const deleteSelectedUsers = createAction('[User/API] Delete Selected Users', props<{ userUIds: string[] }>());
export const reinviteUser = createAction('[User/API] Reinvite User', props<{ user: User }>());

export const setFailedInvites = createAction('[User/API] Set Failed Invites', props<{ failed: FailedInvites }>());
